import { AsyncPipe } from '@angular/common';
import { ChangeDetectionStrategy, Component, DestroyRef, OnDestroy, OnInit } from '@angular/core';
import { OrdersBoardState, OrdersBoardStore } from './orders-board.store';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { Observable } from 'rxjs';
import { RouterLink } from "@angular/router";
import { OrderFaceComponent } from '../../order-face/order-face.component';
import { BOARD_COLUMNS } from './models/order.view-model';

@Component({
  selector: 'orders-board-page',
  templateUrl: './orders-board.page.html',
  styleUrl: './orders-board.page.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [AsyncPipe, RouterLink, OrderFaceComponent]
})
export class OrdersBoardPage implements OnInit, OnDestroy {
  readonly state$: Observable<OrdersBoardState>;
  // the columns and their headers are the layout; they render before the orders do (0128)
  readonly boardColumns = BOARD_COLUMNS;
  // the board's shadow while the orders load: three cards in every column
  readonly shadowCards = [0, 1, 2];

  constructor(
    private store: OrdersBoardStore,
    private destroyRef: DestroyRef
  ) {
    this.state$ = this.store.state$;
  }

  ngOnInit(): void {
    this.store.init().pipe(takeUntilDestroyed(this.destroyRef)).subscribe();
  }

  ngOnDestroy(): void {
    this.store.destroy();
  }
}